import React, { Component } from 'react';
import ProductRow from './ProductRow';

class ProductTable extends React.Component {
  render() {
    var onProductTableUpdate = this.props.onProductTableUpdate;
    var rowDel = this.props.onRowDel;
    var filterText = this.props.filterText;
    var product = this.props.products.map(function (product) {
      if (product.description.indexOf(filterText) === -1) {
        return;
      }
      return (
        <ProductRow
          onProductTableUpdate={onProductTableUpdate}
          product={product}
          onDelEvent={rowDel.bind(this)}
          key={product.id}
        />
      );
    });
    return (
      <div className='col-md-10'>
        <table
          className='table table-bordered table-condensed '
          style={{
            marginTop: '20px',
            color: 'black',
            overflowX: 'auto',
            whiteSpace: 'nowrap',
          }}
        >
          <thead>
            <tr>
              <th>Sl.No</th>
              <th>Description</th>
              <th>Unit</th>
              <th>Qty</th>
              <th>Rate</th>
              <th>Amount</th>
              <th>GST %</th>
              <th>GST Amount</th>
              <th>Total Amount</th>
            </tr>
          </thead>

          <tbody>{product}</tbody>
        </table>
        <span
          className='table-add float-right mb-3 mr-2'
          onClick={this.props.onRowAdd}
        >
          <a
            className='text-success pointer'
            data-toggle='tooltip'
            title='Add row!'
            style={{ cursor: 'pointer' }}
          >
            <i className='fas fa-plus fa-2x' aria-hidden='true'></i>
          </a>
        </span>
      </div>
    );
  }
}

export default ProductTable;
